import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="footerLeft">
        &copy; Copyright Viridi ehf {new Date().getFullYear()}.{" "}
        {t("All Rights Reserved")}
      </div>
      <div className="footerRight">
        <nav className="navbar navbar-expand-lg">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="fa-solid fa-bars"></i>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link to="/aboutus" className="nav-link" aria-current="page">
                  {t("About Us")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/faq" className="nav-link">
                  {t("FAQ")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contactus" className="nav-link">
                  {t("Contact Us")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/privacy" className="nav-link">
                  {t("Privacy Policy")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/terms" className="nav-link">
                  {t("Terms & Conditions")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/solution" className="nav-link">
                  {t("Solution")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/service" className="nav-link">
                  {t("Service")}
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/news" className="nav-link">
                  {t("News")}
                </Link>
              </li>
            </ul>
          </div>
        </nav>

        {/* <div className="socialbg">
          <a href="">
            <i className="fa-brands fa-facebook-f"></i>
          </a>
          <a href="">
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a href="">
            <i className="fa-brands fa-instagram"></i>
          </a>
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
